import React from 'react';
import BurgergerMenu from './BurgerMenu';

const ScrollStickyNav = () => {
  return (
    <div className='ScrollStickyNav'>
      <div className='ScrollStickyNav-burger'>
        <BurgergerMenu />
      </div>
    </div>
  );
};

export default ScrollStickyNav;
